import { render } from "./WithdrawalWhitelistModal.vue?vue&type=template&id=004dcea8&ts=true"
import script from "./WithdrawalWhitelistModal.vue?vue&type=script&lang=ts"
export * from "./WithdrawalWhitelistModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__